import { useState } from 'react'
import SectionLabel from '../components/SectionLabel'
import DepartureRow from '../components/DepartureRow'
import { departures } from '../data/departures'
import { WA_NUMBER, WA_MESSAGES } from '../constants'

export default function Departures() {
  const [filter, setFilter] = useState('all')

  const trekNames = [...new Set(departures.map(d => d.trek))]
  const filtered = filter === 'all' ? departures : departures.filter(d => d.trek === filter)

  return (
    <main style={{ background: 'var(--white)' }}>
      <section style={{ background: 'var(--stone)', padding: '100px 5% 60px', textAlign: 'center' }}>
        <SectionLabel>Plan Your Trip</SectionLabel>
        <h1 className="serif" style={{ fontSize: '48px', fontWeight: 600, marginBottom: '16px' }}>Upcoming departures.</h1>
        <p style={{ color: 'var(--ink-mid)', maxWidth: '520px', margin: '0 auto', fontSize: '15px', fontWeight: 300 }}>
          Small groups of 2-6 people. All dates are guaranteed with a minimum of 2 confirmed trekkers.
        </p>
      </section>

      <section className="section">
        {/* Filter Bar */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginBottom: '48px', flexWrap: 'wrap' }}>
          <button 
            onClick={() => setFilter('all')}
            className="btn btn-sm"
            style={{ 
              background: filter === 'all' ? 'var(--green)' : 'transparent',
              color: filter === 'all' ? 'white' : 'var(--ink)',
              border: '1px solid var(--stone-mid)'
            }}
          >
            All Treks
          </button>
          {trekNames.map(t => (
            <button 
              key={t}
              onClick={() => setFilter(t)}
              className="btn btn-sm"
              style={{ 
                background: filter === t ? 'var(--green)' : 'transparent',
                color: filter === t ? 'white' : 'var(--ink)',
                border: '1px solid var(--stone-mid)'
              }}
            >
              {t}
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '1000px', margin: '0 auto' }}>
          {filtered.length > 0 ? (
            filtered.map(d => (
              <DepartureRow key={d.id} dep={d} />
            ))
          ) : (
            <div style={{ textAlign: 'center', padding: '40px', color: 'var(--ink-light)' }}>
              No scheduled departures found for this filter. WhatsApp me for private options.
            </div>
          )}
        </div>

        {/* Private CTA */}
        <div style={{ 
          marginTop: '80px', 
          textAlign: 'center', 
          background: 'var(--stone)', 
          padding: '60px 40px', 
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--stone-mid)'
        }}>
          <h2 className="serif" style={{ fontSize: '28px', marginBottom: '16px' }}>Want a private departure?</h2>
          <p style={{ color: 'var(--ink-mid)', marginBottom: '32px', maxWidth: '480px', margin: '0 auto 32px', fontWeight: 300 }}>
            Can't find a date that works? I also arrange private departures on any date for solo trekkers or private groups.
          </p>
          <a
            href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.private)}`}
            target="_blank" rel="noreferrer"
            className="btn btn-green"
          >
            Discuss Private Trek
          </a>
        </div>
      </section>
    </main>
  )
}
